import { Pill } from "PFComponents/pill";
import { ColumnHelper } from "PFComponents/table/table.types";
import { ClosureReasonKey, EconomicsVacancy, EconomicsVacancyProfile, Shortlist } from "PFTypes";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import css from "../vacancies_table.module.scss";

type UseStateColumn = {
  shortlists: Shortlist[];
  getVacancyProfile: (vacancy: EconomicsVacancy) => EconomicsVacancyProfile;
};

export const useStateColumn = ({ shortlists, getVacancyProfile }: UseStateColumn) => {
  const { t } = useTranslation("activities", { keyPrefix: "scenario.assignmentTable" });
  const { t: tActivities } = useTranslation("activities");

  return useCallback(
    (columnHelper: ColumnHelper<EconomicsVacancy>) =>
      columnHelper.accessor((row) => row, {
        id: "state",
        header: () => <span className={css.leftMargin}>{t("state")}</span>,
        cell: (info) => {
          const vacancy = info.getValue();

          const vacancyProfile = getVacancyProfile(vacancy);

          if (!vacancyProfile && vacancy.closureReason === ClosureReasonKey.FilledExternally) {
            return (
              <Pill
                small
                classes={{ root: css.leftMargin }}
                text={tActivities(`show.shortlist.state.filled`)}
              />
            );
          }

          if (!vacancyProfile) {
            return <span className={css.leftMargin}>{"-"}</span>;
          }

          const shortlist = shortlists.find(({ profile }) => profile.id === vacancyProfile.id);

          return (
            <Pill
              small
              classes={{ root: css.leftMargin }}
              text={
                shortlist?.state
                  ? tActivities(`show.shortlist.state.${shortlist.state}`)
                  : t("notShortlisted")
              }
            />
          );
        },
        enableSorting: false,
        size: 120
      }),
    [getVacancyProfile, shortlists, t, tActivities]
  );
};
